import { createContext } from 'react'

import { useContextProvider } from './common/components/hooks/useContextProvider'

const Globals = createContext()
const GlobalsProvider = ({ children }) => {
  const context = useContextProvider(dynamicValues)

  return <Globals.Provider value={context}>{children}</Globals.Provider>
}

export { GlobalsProvider, Globals }
